export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getLifestyleActivityList: function getLifestyleActivityList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/activity",
        method: "get",
        params: data
      });
    },
    updateLifestyleActivity: function updateLifestyleActivity() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/lifestyle/activity",
        method: "post",
        data: data
      });
    }
  };
});